exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1gp6t{height:100%;overflow:hidden}", ""]);

// exports
exports.locals = {
	"home-page": "_1gp6t"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[hash:base64:5]","importLoaders":2}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/pages/HomePage/HomePage.scss
// module id = ajSX
// module chunks = 3